import { useLayoutEffect } from "react";

const FIXED_COLUMN_COUNT = 5;
const REPORT_TABLE_SELECTOR =
  ".daily-sale-report-table, .sale-report-table, .quotation-report-table, .cash-register-report-table, .sale-person-report-table, .customer-report-table, .reserve-report-table, .wishlist-report-table, .exchange-report-table, .deposit-report-table, .refund-report-table, .gift-card-report-table, .credit-note-report-table, .custom-order-report-table, .repair-order-report-table, .debit-report-table";

const syncTableStickyOffsets = (table) => {
  const headers = table.querySelectorAll("thead tr:first-child th");
  if (headers.length < FIXED_COLUMN_COUNT) return;

  let left = 0;
  for (let index = 0; index < FIXED_COLUMN_COUNT; index += 1) {
    const width = headers[index].getBoundingClientRect().width;
    table.style.setProperty(`--dsc-left-${index + 1}`, `${left}px`);
    left += width;
  }
};

export const useReportStickyColumns = (containerRef, deps = []) => {
  useLayoutEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const syncAllTables = () => {
      container.querySelectorAll(REPORT_TABLE_SELECTOR).forEach(syncTableStickyOffsets);
    };

    syncAllTables();

    const resizeObserver =
      typeof ResizeObserver !== "undefined"
        ? new ResizeObserver(syncAllTables)
        : null;

    if (resizeObserver) {
      container.querySelectorAll(REPORT_TABLE_SELECTOR).forEach((table) => {
        resizeObserver.observe(table);
      });
    }

    window.addEventListener("resize", syncAllTables);

    return () => {
      resizeObserver?.disconnect();
      window.removeEventListener("resize", syncAllTables);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
